export default __webpack_public_path__ + "static/404-banner-9cbf13644a6b02955dd1445029ba8d2f.jpg";